/**
 * @Author: 韩祺涛
 * @Date: 2022-12-01
 * @Project: 杭氧客户现场使用
 */
export default {
  state: {
    assetTypeCode: {}
  },
  getters: {
    assetTypeCode: state => state.assetTypeCode
  },
  mutations: {
    assetTypeCode: (state, data) => {
      state.assetTypeCode = data
    }
  },
  actions: {
    handleAssetTypeCode (assetTypeCode, data) {
      assetTypeCode.commit('assetTypeCode', data)
    }
  }
}
